import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { NSCommons } from '@ruby/configs/common.constants';
import { ICustomer, ILocation } from '@ruby/modules/customer-select/models/customer.interface';
import { fromReservations, ReservationsActions, ReservationsSelectors } from '@ruby/modules/reservations/store';
import { EReservationGridTitle, EReservationGridType, EReservationType } from '@ruby/shared/enums/reservations.enums';
import { IGridPrintTitle } from '@ruby/shared/models/commons/grid.interface';
import { IReservationDetails } from '@ruby/shared/models/reservations/reservations.interface';

@Component({
  selector: 'ng-reservations-container',
  templateUrl: './reservations.container.html',
  styleUrls: ['./reservations.container.scss']
})
export class ReservationsContainer {
  customerSelected!: ICustomer;
  reservations!: Array<IReservationDetails>;
  title!: EReservationGridTitle;
  name!: EReservationGridType;
  status!: EReservationType;
  printTitle!: IGridPrintTitle;
  store$: Observable<{ state: fromReservations.State; customerSelected?: ICustomer; status?: string }>;

  constructor(private store: Store<fromReservations.State>) {
    this.store$ = this.store.select(ReservationsSelectors.selectReservationsWithStatus).pipe(
      tap((st: { state: fromReservations.State; customerSelected?: ICustomer; status?: string }) => {
        if (st.customerSelected && (this.customerSelected !== st.customerSelected) && st.status) {
          this.customerSelected = st.customerSelected;
          this.printTitle = NSCommons.gridHeader(st.customerSelected);
          if (this.status !== st.status) {
            this.status = st.status as EReservationType;
            this.setUpGridInfo();
            this.dispatchLoadReservations();
          }
        }
      })
    );
  }

  /**
   * Dispatch Load Reservations
   *
   * @summary Dispatches a fetch forReservations
   * @returns void
   */
  dispatchLoadReservations(): void {
    this.store.dispatch(ReservationsActions.loadReservations({
      data: {
        customerId: this.customerSelected.primarySixIds[0],
        locations: this.customerSelected.locations.map((loc: ILocation) => loc.locationName),
        status: this.status
      }
    }));
  }

  private setUpGridInfo(): void {
    switch (this.status) {
      case EReservationType.ACTIVE:
        this.name = EReservationGridType.RESERVATION_ACTIVE;
        this.title = EReservationGridTitle.RESERVATION_ACTIVE;
        break;
      case EReservationType.PENDING:
        this.name = EReservationGridType.RESERVATION_PENDING;
        this.title = EReservationGridTitle.RESERVATION_PENDING;
        break;
      case EReservationType.COMPLETED:
        this.name = EReservationGridType.RESREVATION_COMPLETED;
        this.title = EReservationGridTitle.RESREVATION_COMPLETED;
        break;
      default:
        this.name = EReservationGridType.RESERVATION_ALL;
        this.title = EReservationGridTitle.RESERVATION_ALL;
    }
  }
}
